module.exports = __webpack_public_path__ + "img/font-colors.6688a50a.svg";